
<template>
<div>
    <el-dialog
        :title="$t('UserInfo.PersonalInformation')"
        :visible.sync="dialogVisible"
        width="515px"
        class="dialog"
        >
        <div class="role_type" :style="{left:$i18n.locale==='zh'?'130px':'240px'}">{{userType}}</div>
        <el-form ref="workShopForm" :model="userInfo" label-width="0px">
            <div class="form-box">
            <el-form-item prop="name">
                <div class="label" style="text-align:left">{{$t('UserInfo.Account')}}</div>
                <el-input v-model.trim="userInfo.name" disabled/>
            </el-form-item>
            </div>

            <div class="form-box">
            <el-form-item prop="nickname">
                <div class="label" style="text-align:left">{{$t('UserInfo.UserName')}}</div>
                <el-input v-model.trim="userInfo.nickname" :placeholder="$t('Setting.IpUserName')" auto-complete="off" clearable/>
            </el-form-item>
            </div>
            <div class="form-box">
            <el-form-item prop="name">
                <div class="label" style="text-align:left">{{$t('Login.MobilePhone')}}</div>
                <el-input v-model.trim="userInfo.phone" :placeholder="$t('Login.phoneNumber')" auto-complete="off" clearable />
            </el-form-item>
            </div>
            <div class="form-box">
            <el-form-item prop="email">
                <div class="label" style="text-align:left">{{$t('Login.Email')}}</div>
                <el-input v-model.trim="userInfo.email" :placeholder="$t('Setting.IptEmail')" auto-complete="off"  clearable/>
            </el-form-item>
            <el-form-item prop="name">
                <div class="label" style="text-align:left">{{$t('UserInfo.Workshop')}}</div>
                <div class="workshopList">
                    <div class="workshopItem" v-for="item in workshops" :key="item.id">{{item.name}}</div>
                </div>

            </el-form-item>
            </div>
            <div class="forget_pwd" @click="forget">{{$t('Login.ForgotPassword')}}?</div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <div class="btn-normal pan-btn blue-btn" style="margin-right:0px;background:#4875ef" @click="handleConfirm()">{{$t('Login.OK')}}</div>
            <div class="btn-normal pan-btn tiffany-btn" @click="dialogVisible = false" style='background:#767e95'>{{$t('AddMachine.Cancel')}}</div>
        </span>
        </el-dialog>
    <el-dialog
        :title="$t('UserInfo.ChangePassword')"
        :visible.sync="dialogPwd"
        width="600px"
        class="dialog dialogs"
        >
        <el-form ref="workShopForm" :model="userInfo" label-width="0px">

            <div class="form-box">
            <el-form-item prop="nickname">
                <div class="label" style="text-align:left">{{$t('UserInfo.CurrentPassword')}}</div>
                <el-input v-model.trim="userPwd.currentPwd" auto-complete="new-password"  :placeholder="$t('Setting.oldPwd')"   type="password" clearable/>
            </el-form-item>
            </div>
            <div class="form-box">
            <el-form-item prop="name">
                <div class="label" style="text-align:left">{{$t('UserInfo.NewPassword')}}</div>
                <el-input v-model.trim="userPwd.newPwd" :placeholder="$t('Login.resetThePassword')" auto-complete="new-password"  type="password" clearable/>
            </el-form-item>
            </div>
            <div class="form-box">
            <el-form-item prop="name">
                <div class="label" style="text-align:left">{{$t('Login.ConfirmPassword')}}</div>
                <el-input v-model.trim="userPwd.confirePwd" :placeholder="$t('Login.newpassword')" auto-complete="new-password"  type="password" clearable/>
            </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <div class="btn-normal pan-btn blue-btn" style="margin-right:0px;background:#4875ef" @click="handlePwd()">{{$t('Login.OK')}}</div>
            <div class="btn-normal pan-btn tiffany-btn" @click="dialogPwd = false,dialogVisible=true" style='background:#767e95'>{{$t('AddMachine.Cancel')}}</div>
        </span>
        </el-dialog>
</div>
</template>
<script>
import { getUserInfo, changePwd, changeInfo } from '../../api/layout'
export default {
  name: 'userInfo',
  data () {
    return {
      // 用户信息对象
      userInfo: {
        email: '',
        phone: '',
        nickname: '',
        name: ''
      },
      // 修改用户密码对象
      userPwd: {
        newPwd: '',
        currentPwd: '',
        confirePwd: ''
      },
      workshops: [], // 车间数组
      repeat: true,
      repeatPower: true,
      userType: '', // 用户权限对象
      dialogPwd: false, // 修改密码弹窗
      dialogVisible: false // 用户信息弹窗
    }
  },
  created () {
    // 获取当前用户角色
    this.userType = parseInt(localStorage.getItem('rid')) === 3 ? this.$t('UserInfo.SuperAdministrator') : parseInt(localStorage.getItem('rid')) === 4 ? this.$t('UserInfo.Administrators') : this.$t('UserInfo.User')
  },
  watch: {
    // 监听当前语言
    '$i18n.locale' (val) {
      this.changeLan()
    }
  },
  methods: {
    // 管理员或超级管理员、用户的多语言
    changeLan () {
      this.userType = parseInt(localStorage.getItem('rid')) === 3 ? this.$t('UserInfo.SuperAdministrator') : parseInt(localStorage.getItem('rid')) === 4 ? this.$t('UserInfo.Administrators') : this.$t('UserInfo.User')
    },
    // 默认车间多语言
    changeLanWork () {
      for (var i = 0; i < this.workshops.length; i++) {
        if (this.workshops[i].name === '默认车间' || this.workshops[i].name === 'Default Workshop') {
          this.$set(this.workshops[i], 'name', this.$t('Tip.Default'))
        }
      }
    },
    // 打开忘记密码页面，并初始化数据
    forget () {
      this.userPwd.newPwd = ''
      this.userPwd.currentPwd = ''
      this.userPwd.confirePwd = ''
      this.dialogVisible = false
      this.dialogPwd = true
    },
    // 邮箱校验匹配方法
    checkEmail (val) {
      const t = /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/
      if (!(t.test(val))) {
        return false
      } else {
        return true
      }
    },
    // 修改密码API
    async handlePwd () {
      if (!this.repeat) {
        return
      }
      this.repeat = false
      setTimeout(() => {
        this.repeat = true
      }, 2000)
      if (!this.userPwd.currentPwd) {
        this.$message({
          showClose: true,
          message: this.$t('Setting.oldPwd'),
          type: 'warning',
          duration: 1000
        })
        return
      }
      if (!this.userPwd.newPwd) {
        this.$message({
          showClose: true,
          message: this.$t('Setting.newPwd'),
          type: 'warning',
          duration: 1000
        })
        return
      }
      if (this.userPwd.newPwd.length < 6) {
        this.$message({
          showClose: true,
          message: this.$t('Tip.Digits'),
          type: 'warning',
          duration: 1000
        })
        return
      }
      if (this.userPwd.newPwd !== this.userPwd.confirePwd) {
        this.$message({
          showClose: true,
          message: this.$t('Tip.Inconsistent'),
          type: 'warning',
          duration: 1000
        })
        return
      }
      const params = {}
      // 密码需要MD5加密
      params.old_pwd = this.$md5(this.userPwd.currentPwd)
      params.new_pwd = this.$md5(this.userPwd.newPwd)
      const token = localStorage.getItem('token')
      const lang = localStorage.getItem('language')
      await changePwd(params, token, lang).then((res) => {
        if (res.code === 200) {
          this.$message({
            showClose: true,
            message: this.$t('Tip.Modified'),
            type: 'success',
            duration: 1000
          })
          // 修改密码之后跳回登录页
          this.$router.push('/')
        }
      })
    },
    // 获取用户信息
    getUserInfo () {
      const params = {}
      params.token = localStorage.getItem('token')
      params.language = localStorage.getItem('language')
      getUserInfo(params).then((res) => {
        this.userInfo.name = res.data.account
        this.userInfo.nickname = res.data.nickname
        this.userInfo.phone = res.data.mobile
        this.userInfo.email = res.data.email
        this.workshops = res.data.workshop
        this.changeLan()
        this.changeLanWork()
        // this.userPwd.currentPwd = res.data
      })
    },
    // 用户信息弹窗
    showUser () {
      this.dialogVisible = true
      this.getUserInfo()
    },
    // 确定修改用户信息API
    handleConfirm () {
      if (!this.repeatPower) {
        return
      }
      this.repeatPower = false
      setTimeout(() => {
        this.repeatPower = true
      }, 2000)
      if (!this.checkEmail(this.userInfo.email)) {
        this.$message({
          showClose: true,
          message: this.$t('Setting.ErrEmail'),
          type: 'warning',
          duration: 1000
        })
        return
      }
      if (!this.userInfo.phone) {
        this.$message({
          showClose: true,
          message: this.$t('Login.phoneNumber'),
          type: 'warning',
          duration: 1000
        })
        return
      }
      const params = {}
      params.email = this.userInfo.email
      params.mobile = this.userInfo.phone
      params.nickname = this.userInfo.nickname
      const token = localStorage.getItem('token')
      const lang = localStorage.getItem('language')

      changeInfo(params, token, lang).then((res) => {
        if (res.code === 200) {
          this.dialogVisible = false
          // 本地存储用户昵称，并且将用户昵称传给左下角
          localStorage.setItem('nickname', this.userInfo.nickname)
          this.$bus.$emit('changeNick', this.userInfo.nickname)
          this.$message({
            showClose: true,
            message: this.$t('Tip.EditSuccess'),
            type: 'success',
            duration: 1000
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@media  (max-width:1441px) {
  .dialog /deep/.el-input__suffix {
      right: 20px !important;
  }
}
.dialogs /deep/ .el-dialog {
  margin-top: 22vh !important;
}
.dialog /deep/ .el-input__suffix {
    right: 20px;
}
.role_type{
  font-size: 14px;
  position: absolute;
  top:24px
}
.workshopList{
    // display: flex;
    // flex-direction: row;
    font-size: 14px;
    .workshopItem{
        float: left;
        text-align: left;
        margin-right: 20px;
        height: 20px;
        line-height: 20px;
    }
}
.forget_pwd{
    font-size: 18px;
    text-align: left;
    color: #4875ef;
    padding: 10px 0;
    position: absolute;
    bottom: 16px;
    letter-spacing: 1px;
    cursor: pointer;
}
.dialog /deep/ .el-dialog{
    border-radius: 20px !important;
    background: #e7e9ee;
}
.dialog /deep/ .el-dialog__body {
    padding: 0px 30px 10px 30px;
}
.btn-normal {
    width: 70px;
    height: 32px;
    border-radius: 20px;
    font-size: 13px;
    line-height: 34px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    float: right;
    margin-left: 10px;
    cursor: pointer;
}
.dialog /deep/ .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
}
.dialog /deep/ .el-form-item__content {
    line-height: 35px;
    font-size: 18px;
  }
.dialog /deep/ .el-select {
  width: 100%;
}
.dialog /deep/ .el-select  .el-input--suffix {
    width: 100% !important;
    padding-right: 0px;
}
.dialog /deep/ .el-input {
    float: left;
    padding-right: 15px;
    // width: 80% !important;
}
.dialog /deep/ .plan-form.r3 .label {
    font-size: 16px;
}
.dialog /deep/ .el-input--suffix {
  width: 100% !important;
  padding-right: 15px;
}
.dialog /deep/ .plan-form .row .form-item{
    width: 33.4% !important;
}
.dialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 20px;
}
.dialog /deep/ .el-dialog__body{
  padding: 20px 30px !important;
}
.dialog /deep/ .el-dialog__header {
    padding: 20px 30px 10px !important;
    text-align: left;
}
.dialog /deep/ .el-dialog__headerbtn{
  font-size: 30px !important;
  top: 12px;
}
.dialog /deep/ .el-dialog__footer {
    padding: 0px 20px 15px !important;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
}

</style>
